import { USER_TYPE } from "../constants";

export const initialState = {
  accountDetail: null,
  user: {
    email: '',
    password: '',
  },
  userData: {},
  isValid: false,
  error: false,
  loading: false,
  errorMsg: '',
  jwtToken: '',
  refreshToken: '',
  email: '',
  isAuthenticated: '',
  accTokenUserRole: '',
  userType: USER_TYPE.internalUser,
  hideSidebar: false,
  authorizationData: [],
  refreshTokenCount: 0,
};
